import { Link } from "react-router-dom";
import { MapPin, Phone, Envelope, InstagramLogo, FacebookLogo, GoogleLogo, WhatsappLogo } from "@phosphor-icons/react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_pixora-moments/artifacts/xaiv43xy_RECTO.png";

export default function Footer() {
  return (
    <footer className="bokeh-section border-t border-[#C9A962]/20 pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="PIXORA — Photobooth Premium" 
              className="h-32 w-auto -ml-3 mb-2 object-contain"
            />
            <p className="text-[#B8A88A] text-sm">
              Capturez. Souriez. Partagez.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[#C9A962] font-semibold mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#B8A88A] hover:text-[#C9A962] text-sm transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/tarifs-particuliers" className="text-[#B8A88A] hover:text-[#C9A962] text-sm transition-colors">
                  Tarifs Particuliers
                </Link>
              </li>
              <li>
                <Link to="/tarifs-professionnels" className="text-[#B8A88A] hover:text-[#C9A962] text-sm transition-colors">
                  Tarifs Professionnels
                </Link>
              </li>
              <li>
                <Link to="/photobooth-bourgoin-jallieu" className="text-[#B8A88A] hover:text-[#C9A962] text-sm transition-colors" data-testid="footer-link-bourgoin">
                  Photobooth Bourgoin-Jallieu
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#B8A88A] hover:text-[#C9A962] text-sm transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Zone d'intervention */}
          <div>
            <h4 className="text-[#C9A962] font-semibold mb-4">Zone d'intervention</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2 text-[#B8A88A] text-sm">
                <MapPin size={16} className="text-[#C9A962] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white">Nord Isère & Est Lyonnais</p>
                  <p>225 avenue des marronniers</p>
                  <p>38300 Bourgoin-Jallieu</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#C9A962] font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="mailto:pixora.photobooth38@gmail.com" 
                  className="flex items-center gap-2 text-[#B8A88A] hover:text-[#C9A962] text-sm transition-colors"
                >
                  <Envelope size={16} className="text-[#C9A962]" />
                  pixora.photobooth38@gmail.com
                </a>
              </li>
              <li>
                <a 
                  href="tel:0745709881" 
                  className="flex items-center gap-2 text-[#B8A88A] hover:text-[#C9A962] text-sm transition-colors"
                >
                  <Phone size={16} className="text-[#C9A962]" />
                  07 45 70 98 81
                </a>
              </li>
            </ul>
            
            {/* Social */}
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.facebook.com/profile.php?id=61591579986105&locale=fr_FR" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook Pixora"
                className="p-2 rounded-full bg-[#C9A962]/10 border border-[#C9A962]/30 hover:bg-[#C9A962]/20 hover:border-[#C9A962] transition-all"
                data-testid="social-facebook"
              >
                <FacebookLogo size={20} className="text-[#C9A962]" />
              </a>
              <a 
                href="https://www.instagram.com/pixoraphotobooth38/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram Pixora"
                className="p-2 rounded-full bg-[#C9A962]/10 border border-[#C9A962]/30 hover:bg-[#C9A962]/20 hover:border-[#C9A962] transition-all"
                data-testid="social-instagram"
              >
                <InstagramLogo size={20} className="text-[#C9A962]" />
              </a>
              <a 
                href="https://wa.me/33745709881" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="WhatsApp Pixora"
                className="p-2 rounded-full bg-[#C9A962]/10 border border-[#C9A962]/30 hover:bg-[#C9A962]/20 hover:border-[#C9A962] transition-all"
                data-testid="social-whatsapp"
              >
                <WhatsappLogo size={20} className="text-[#C9A962]" />
              </a>
              <a 
                href="https://share.google/ogjMbSTaL44H7LHvS" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Google Pixora"
                className="p-2 rounded-full bg-[#C9A962]/10 border border-[#C9A962]/30 hover:bg-[#C9A962]/20 hover:border-[#C9A962] transition-all"
                data-testid="social-google"
              >
                <GoogleLogo size={20} className="text-[#C9A962]" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#C9A962]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#8A7A5A] text-sm">
              © {new Date().getFullYear()} PIXORA. Tous droits réservés.
            </p>
            <div className="flex gap-6">
              <Link to="/mentions-legales" className="text-[#8A7A5A] hover:text-[#C9A962] text-sm transition-colors" data-testid="footer-mentions-legales">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="text-[#8A7A5A] hover:text-[#C9A962] text-sm transition-colors" data-testid="footer-politique-confidentialite">
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
